import React from 'react';
// import logo from './logo.svg';
// import './App.css';
import { Grommet, Header,Button, Text, Box } from "grommet";
import { BrowserRouter, Route, Routes, Navigate, useNavigate } from "react-router-dom";

import {grommetKnueTheme} from "./config/design"

import CenterAbout from './pages/center/CenterAbout';
import CenterMain from './pages/CenterMain';
import StatisticsMain from './pages/archive/StatisticsMain';
import CatalogueMain from './pages/archive/CatalogueMain';
import CatalogueBook from "./pages/archive/CatalogueBook";
import LawMain from './pages/archive/LawMain';
import GazetteMain from './pages/archive/GazetteMain';
import MagazineMain from './pages/archive/MagazineMain';
import NewspaperMain from './pages/archive/NewspaperMain';
import BulletinMain from './pages/archive/BulletinMain';
import AlbumMain from './pages/archive/AlbumMain';
import AlumniMain from './pages/archive/AlumniMain';
import BiographyMain from './pages/archive/BiographyMain';
import SchoolCatalogueMain from './pages/archive/SchoolCatalogueMain';
import EtcMain from './pages/archive/EtcMain';
import ThesisMain from './pages/archive/ThesisMain';
import BookMain from './pages/archive/BookMain';

import ArchiveMain from './pages/ArchiveMain';
import SchoolMain from './pages/center/SchoolMain';
import EventMain from './pages/center/EventMain';
import DocumentMain from './pages/archive/DocumentMain';

import ArticleMain from './pages/archive/ArticleMain';
import BackgroundImage from './shared_comp/BackgroundImage';
import KnueHeader from './shared_comp/KnueHeader';
import StatisticsBook from './pages/archive/StatisticsBook';

import PagePersonMain from './pages/mainpage/PagePersonMain';
import PageEventMain from './pages/mainpage/PageEventMain';
import PageInstMain from './pages/mainpage/PageInstMain';

import PageRedbookMain from './pages/redbook/PageRedbookMain';
import PageRedbookUnit from './pages/redbook/PageRedbookUnit';
import PageRedbookInst from './pages/redbook/PageRedbookInst';
import PageRedbookAnalysis from './pages/redbook/PageRedbookAnalysis';

function App() {

  return (
    <BrowserRouter>
      <Grommet theme={grommetKnueTheme} full>
        <KnueHeader />
        <BackgroundImage />
        <Box
          style={{ position: "absolute", top: "80px", minWidth:"300px" }}
          width="full"
          height="90%"

        >
          <Routes>
            <Route path="/" element={<ArchiveMain />} />
            <Route path="/about" element={<CenterAbout />} />
            <Route path="/person" element={<PagePersonMain />} />
            <Route path="/school" element={<PagePersonMain />} />
            <Route path="/inst" element={<PageInstMain />} />
            <Route path="/event" element={<PageEventMain />} />
            <Route path="/redbooks" element={<PageRedbookMain />} />
            <Route path="/redbook" element={<PageRedbookUnit/>}/>
            <Route path="/redbook_inst" element={<PageRedbookInst/>}/>
            <Route path="/redbook_analysis" element={<PageRedbookAnalysis/>}/>
            <Route path="/archive" element={<ArchiveMain />} />
            <Route path="/archive/statistics" element={<StatisticsMain />} />
            <Route path="/archive/statisticsbook" element={<StatisticsBook/>}/>
            <Route path="/archive/catalogue" element={<CatalogueMain />} />
            <Route path="/archive/cataloguebook" element={<CatalogueBook />} />
            <Route path="/archive/law" element={<LawMain />} />
            <Route path="/archive/gazette" element={<GazetteMain />} />
            <Route path="/archive/document" element={<DocumentMain />} />
            <Route path="/archive/magazine" element={<MagazineMain />} />
            <Route path="/archive/newspaper" element={<NewspaperMain />} />
            <Route path="/archive/bulletin" element={<BulletinMain />} />
            <Route path="/archive/album" element={<AlbumMain />} />
            <Route path="/archive/alumni" element={<AlumniMain />} />
            <Route path="/archive/biography" element={<BiographyMain />} />
            <Route path="/archive/schoolcatalogue" element={<SchoolCatalogueMain />} />
            <Route path="/archive/etc" element={<EtcMain />} />
            <Route path="/archive/thesis" element={<ThesisMain />} />
            <Route path="/archive/article" element={<ArticleMain />} />
            <Route path="/archive/book" element={<BookMain />} />
          </Routes>
        </Box>
      </Grommet>
    </BrowserRouter>
  );
}

export default App;
